import { createMuiTheme } from '@material-ui/core/styles'
import { blue, orange, red } from '@material-ui/core/colors'

export const Theme = createMuiTheme({
    palette: {
        primary: {
            main: blue[500]
        },
        action: {
            main: orange[500]
        },
        text_weak: {
            main: '#333'
        }, 
        text_strong: {
            main: 'black'
        },
        icons: {
            main: red[500]
        },
        background: {
            main: 'white'
        },
        infobox_bg: {
            main: 'rgb(182, 209, 236)'
        }
    }
})
